import React, { useState } from "react";
import PersonRow from "./PersonRow";

const INITIAL_SHOW = 20;

function BranchCard({ branch, variant = "default" }) {
  const [expanded, setExpanded] = useState(false);
  const [showAll, setShowAll] = useState(false);

  const visibleMembers =
    expanded && !showAll
      ? branch.members.slice(0, INITIAL_SHOW)
      : expanded
        ? branch.members
        : [];

  const hasMore = branch.members.length > INITIAL_SHOW;

  // Build a short origin description
  const originText = branch.origins
    .map((o) => {
      const name = [o.firstName, o.lastName, o.suffix].filter(Boolean).join(" ");
      return o.birthYear ? `${name} (b. ${o.birthYear})` : name;
    })
    .join("; ");

  // Generation span text (e.g. "Generations 01–11")
  const genSpan =
    branch.earliestGen && branch.latestGen
      ? branch.earliestGen === branch.latestGen
        ? `Generation ${branch.earliestGen}`
        : `Generations ${branch.earliestGen}\u2013${branch.latestGen}`
      : null;

  const isOriginal = variant === "original";

  return (
    <div
      className={`rounded-lg overflow-hidden transition-shadow hover:shadow-md ${
        isOriginal
          ? "border-[3px] border-dupontGold bg-dupontCream dark:bg-darkCard"
          : "border-2 border-dupontGold bg-white dark:bg-darkCard"
      }`}
    >
      {/* Clickable header */}
      <button
        type="button"
        className={`w-full flex items-center justify-between px-[16px] text-left cursor-pointer transition-colors ${
          isOriginal
            ? "py-[16px] hover:bg-dupontCreamDk dark:hover:bg-darkElevated"
            : "py-[12px] hover:bg-dupontCream dark:hover:bg-darkElevated"
        }`}
        onClick={() => setExpanded((prev) => !prev)}
      >
        <div className="flex flex-col gap-y-[2px]">
          <span
            className={`font-display font-semibold text-dupontBlue dark:text-darkText ${
              isOriginal ? "text-2xl" : "text-lg"
            }`}
          >
            {branch.displayName}
          </span>
          <span className={`text-dupontGray dark:text-darkTextSecondary ${isOriginal ? "text-sm" : "text-[13px]"}`}>
            {branch.count.toLocaleString()} {branch.count === 1 ? "person" : "people"}
            {genSpan ? ` \u00B7 ${genSpan}` : ""}
            {originText ? ` \u00B7 Founded by ${originText}` : ""}
          </span>
        </div>
        <span className="text-dupontGold text-xl select-none">
          {expanded ? "\u25B2" : "\u25BC"}
        </span>
      </button>

      {/* Expanded member list */}
      {expanded && (
        <div className="border-t border-dupontGold/30 px-[8px] py-[8px]">
          {branch.multipleOrigins && (
            <div className="text-[13px] text-dupontGoldDk italic px-[8px] pb-[4px]">
              This surname entered the family through {branch.origins.length} separate lines.
            </div>
          )}

          {visibleMembers.map((person) => (
            <PersonRow key={person.id} person={person} />
          ))}

          {hasMore && !showAll && (
            <button
              type="button"
              className="mt-[4px] ml-[8px] text-sm text-dupontGold hover:text-dupontGoldDk underline cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setShowAll(true);
              }}
            >
              Show all {branch.members.length.toLocaleString()} members
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default BranchCard;
